import { render, staticRenderFns } from "./LocalitiesCard.vue?vue&type=template&id=cf6eb752"
import script from "./LocalitiesCard.vue?vue&type=script&lang=js"
export * from "./LocalitiesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports